import React from "react";
import { Typography, Paper, makeStyles, CircularProgress } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const useStyles = makeStyles((theme) => ({
  previewBox: {
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.default,
    borderRadius: 8,
    border: `1px dashed ${theme.palette.divider}`,
    minHeight: 250,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  summaryItem: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 8,
  }
}));

const StepPreview = ({ formData, isGenerating, videoUrl }) => {
  const classes = useStyles();

  return (
    <div>
      <Typography variant="h6" gutterBottom>
        Resumen Final
      </Typography>
      <Typography variant="body2" color="textSecondary" style={{ marginBottom: 24 }}>
        Revisa las configuraciones. Cuando estés listo, haz clic en el botón "Generar Video Mágico" debajo.
      </Typography>

      <Paper elevation={0} style={{ padding: 24, marginBottom: 24, border: "1px solid #eee" }}>
        <div className={classes.summaryItem}>
          <CheckCircleIcon color="primary" fontSize="small" />
          <Typography variant="body1">
            <strong>Formato:</strong> {formData.format.toUpperCase()}
          </Typography>
        </div>
        <div className={classes.summaryItem}>
          <CheckCircleIcon color="primary" fontSize="small" />
          <Typography variant="body1">
            <strong>Personaje:</strong> {formData.avatarFile ? "Foto Subida Personalizada" : `Stock ID: ${formData.avatarId || "N/A"}`}
          </Typography>
        </div>
        <div className={classes.summaryItem}>
          <CheckCircleIcon color="primary" fontSize="small" />
          <Typography variant="body1">
            <strong>Voz:</strong> {formData.voiceSampleFile ? "Voz Clonada Personalizada" : `Stock ID: ${formData.voiceActor}`}
          </Typography>
        </div>
        <div className={classes.summaryItem}>
          <CheckCircleIcon color="primary" fontSize="small" />
          <Typography variant="body1">
            <strong>Logo / Marca:</strong> {formData.logoFile ? "Logo Personalizado Incluido" : "Sin Logo"}
          </Typography>
        </div>
        <div className={classes.summaryItem}>
          <CheckCircleIcon color="primary" fontSize="small" />
          <Typography variant="body1">
            <strong>Música:</strong> {formData.useMusic ? formData.musicTrack : "Sin Música"} | <strong>Subtítulos:</strong> {formData.useSubtitles ? "Sí" : "No"}
          </Typography>
        </div>
      </Paper>

      <div className={classes.previewBox}>
        {videoUrl ? (
          <video src={videoUrl} controls style={{ width: '100%', maxWidth: 400, borderRadius: 8 }} />
        ) : isGenerating ? (
          <>
            <CircularProgress size={60} style={{ marginBottom: 16 }} />
            <Typography variant="h6">Creando tu obra maestra...</Typography>
            <Typography variant="body2" color="textSecondary" align="center" style={{ maxWidth: 400 }}>
              Estamos mezclando tu avatar, la voz generada y aplicando inteligencia artificial cinematográfica. Esto tomará un par de minutos. No cierres esta ventana.
            </Typography>
          </>
        ) : (
          <Typography variant="body2" color="textSecondary" align="center">
            El video aparecerá aquí una vez finalizado.
          </Typography>
        )}
      </div>
    </div>
  );
};

export default StepPreview;
